/**
 * Storage Isolation for Demo Iframes
 * 
 * When running inside demo iframes with ?ctx=<prefix>, all sessionStorage
 * keys are transparently prefixed so separate iframes don't share auth state.
 * This runs once at boot and is invisible to all other code.
 */
(function () {
  try {
    const params = new URLSearchParams(window.location.search);
    const ctx = params.get('ctx');
    if (!ctx) return; // No isolation needed — production behaviour unchanged

    const prefix = ctx + '_';

    // If fresh=1, wipe any stale prefixed keys before starting (e.g. after preset reset)
    if (params.get('fresh') === '1') {
      Object.keys(sessionStorage)
        .filter(k => k.startsWith(prefix))
        .forEach(k => sessionStorage.removeItem(k));
    }

    const origGet = sessionStorage.getItem.bind(sessionStorage);
    const origSet = sessionStorage.setItem.bind(sessionStorage);
    const origRemove = sessionStorage.removeItem.bind(sessionStorage);

    sessionStorage.getItem = function (key) {
      return origGet(prefix + key);
    };
    sessionStorage.setItem = function (key, value) {
      return origSet(prefix + key, value);
    };
    sessionStorage.removeItem = function (key) {
      return origRemove(prefix + key);
    };
  } catch (e) {
    // Silently ignore — isolation is a nice-to-have for demo only
  }
})();
